/**
 *  @fileOverview Accordion module
 *
 *  @author Andras Muk <andras.muk@possible.com>
 */

import forEach from 'lodash/forEach';

const COLLAPSED_CLASS = 'collapsible__box--collapsed';

class Accordion {
  init() {
    this.onClickBind = this.toggleAccordion.bind(this);
    this.onKeyUpBind = this.cancelKeyup.bind(this);
    this.initBindings();
  }

  initDOMElements() {
    this.accordionWrapper = document.querySelectorAll('[data-accordion]');
    if (this.accordionWrapper) {
      this.accordionButtons = document.body.querySelectorAll('[data-accordion] button');
    }
  }

  initBindings() {
    this.initDOMElements();
    if (this.accordionWrapper) {
      this.addBindings();
    }
  }

  addBindings() {
    forEach(this.accordionButtons, (element) => {
      if (document.body.classList.contains('pagemode-edit') === true) {
        element.addEventListener('keyup', this.onKeyUpBind, false);
      } else {
        element.addEventListener('click', this.onClickBind, false);
      }
      const id = element.getAttribute('id');
      const content = document.querySelector(`[aria-labelledby="${id}"]`);
      if (content !== null) {
        this.setContentAccessibility(content, false);
      }
    });
  }

  setContentAccessibility(content, isActive) {
    forEach(content.querySelectorAll('a'), (link) => {
      if (isActive === true) {
        link.removeAttribute('tabindex');
      } else {
        link.setAttribute('tabindex', '-1');
      }
    });

    forEach(content.querySelectorAll('input'), (link) => {
      if (isActive === true) {
        link.removeAttribute('tabindex');
        link.removeAttribute('disabled');
      } else {
        link.setAttribute('tabindex', '-1');
        link.setAttribute('disabled', '');
      }
    });
  }

  destroyBindings() {
    forEach(this.accordionButtons, (element) => {
      element.removeEventListener('keyup', this.onKeyUpBind);
      element.removeEventListener('click', this.onClickBind);
    });
  }

  cancelKeyup(e) {
    if (e.keyCode === 32) {
      e.preventDefault();
    }
    return false;
  }

  toggleAccordion(e) {
    const element = e.currentTarget;
    const buttonId = element.getAttribute('id');
    const target = document.querySelector(`[aria-labelledby="${buttonId}"]`);
    const isCollapsed = target.classList.contains(COLLAPSED_CLASS);

    element.setAttribute('aria-expanded', isCollapsed.toString());

    if (isCollapsed) {
      element.classList.add('active');
      target.style.height = `${target.scrollHeight + 55}px`;
      target.classList.remove(COLLAPSED_CLASS);
      target.setAttribute('aria-expanded', true);
      this.setContentAccessibility(target, true);
    } else {
      element.classList.remove('active');
      target.style.height = 0;
      target.classList.add(COLLAPSED_CLASS);
      target.setAttribute('aria-expanded', false);
      this.setContentAccessibility(target, false);
    }
  }
}

export const accordion = new Accordion();



// WEBPACK FOOTER //
// ./src/js/modules/accordion.js